<template>
  <div class="flex flex-col justify-start">
    <div class="mb-4 border-b border-truegray-300">
      <h1 class="mb-6">
        CareerWise <span class="hotshot font-primary">hotshots</span>
      </h1>
      <button
        :class="
          active_range === '90days' ? 'hotshot font-bold' : 'text-truegray-300'
        "
        class="py-4 pr-4 text-xs hover:text-cw-alt cursor-pointer transition-all duration-300"
        @click="getStatsLeaders('90days')"
      >
        90 Days
      </button>
      <button
        :class="
          active_range === 'alltime' ? 'hotshot font-bold' : 'text-truegray-300'
        "
        class="py-4 pr-4 text-xs hover:text-cw-alt cursor-pointer transition-all duration-300"
        @click="getStatsLeaders('alltime')"
      >
        All Time
      </button>
    </div>
    <div class="w-full">
      <div
        :class="[
          loaded
            ? 'opacity-100 loading-animation'
            : 'opacity-0 pointer-events-none absolute',
        ]"
        class="w-full flex space-x-10 flex-row"
      >
        <div class="flex flex-col w-1/3">
          <div class="flex space-x-2 items-center mt-4">
            <img
              class="h-8"
              src="/img/cloud_badges/badge_posts_gold.png"
              alt="CareerWise tenant category leader badge"
            />
            <h3 class="text-lg mb-0">Posts</h3>
          </div>
          <div class="w-full flex flex-col justify-center">
            <div
              v-for="(leader, i) in cloudTenantLeaders.posts"
              :key="i"
              class="flex items-center my-4"
            >
              <h6 v-if="i === 0" class="text-xs text-truegray-500 mr-2">1st</h6>
              <h6 v-if="i === 1" class="text-xs text-truegray-500 mr-2">2nd</h6>
              <h6 v-if="i === 2" class="text-xs text-truegray-500 mr-2">3rd</h6>
              <div
                class="rounded-full flex items-center justify-center border-2 shrink-0 w-12 h-12 mr-2 relative"
              >
                <div
                  v-if="leader.logo"
                  class="bg-no-repeat bg-cover bg-center w-8 h-8 rounded-full"
                  :style="{ backgroundImage: 'url(' + leader.logo + ')' }"
                ></div>
                <div
                  v-else
                  class="flex justify-center items-center w-8 h-8 rounded-full text-cw-900"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-8 w-8"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </div>

                <!-- Badge container -->
                <div
                  :style="{ top: '0.5rem' }"
                  class="w-full h-full absolute left-0 flex items-end justify-center"
                >
                  <img
                    v-if="i === 0"
                    class="h-5"
                    src="/img/cloud_badges/badge_posts_gold.png"
                    alt="CareerWise tenant category leader badge"
                  />
                  <img
                    v-if="i === 1"
                    class="h-5"
                    src="/img/cloud_badges/badge_posts_silver.png"
                    alt="CareerWise tenant category leader badge"
                  />
                  <img
                    v-if="i === 2"
                    class="h-5"
                    src="/img/cloud_badges/badge_posts_bronze.png"
                    alt="CareerWise tenant category leader badge"
                  />
                </div>
              </div>
              <div class="flex flex-1 items-center justify-between space-x-2">
                <div class="">
                  <h6
                    v-if="leader.name"
                    :style="{ maxWidth: '100px' }"
                    class="text-truegray-500"
                  >
                    {{ leader.name }}
                  </h6>
                  <a
                    ref="viewProfile"
                    :href="settings.cloud_domain + '/school/' + leader.id"
                    target="_blank"
                    class="text-xs text-truegray-400 hover:text-cw-alt no-underline italic"
                    ><h6>cloud profile</h6></a
                  >
                </div>
                <h6
                  v-if="leader.total"
                  class="text-xs text-expo_red mb-0 font-bold"
                >
                  {{ leader.total }}
                </h6>
              </div>
            </div>
          </div>
        </div>

        <div class="flex flex-col w-1/3">
          <div class="flex space-x-2 items-center mt-4">
            <img
              class="h-8"
              src="/img/cloud_badges/badge_shares_gold.png"
              alt="CareerWise tenant category leader badge"
            />
            <h3 class="text-lg mb-0">Shares</h3>
          </div>
          <div class="w-full flex flex-col justify-center">
            <div
              v-for="(leader, i) in cloudTenantLeaders.shares"
              :key="i"
              class="flex items-center my-4"
            >
              <a
                ref="viewProfile"
                :href="settings.cloud_domain + 'school/' + leader.id"
                target="_blank"
                class="hidden"
              ></a>
              <h6 v-if="i === 0" class="text-xs text-truegray-500 mr-2">1st</h6>
              <h6 v-if="i === 1" class="text-xs text-truegray-500 mr-2">2nd</h6>
              <h6 v-if="i === 2" class="text-xs text-truegray-500 mr-2">3rd</h6>

              <div
                class="rounded-full flex items-center justify-center border-2 shrink-0 w-12 h-12 mr-2 relative"
              >
                <div
                  v-if="leader.logo"
                  class="bg-no-repeat bg-cover bg-center w-8 h-8 rounded-full"
                  :style="{ backgroundImage: 'url(' + leader.logo + ')' }"
                ></div>
                <div
                  v-else
                  class="flex justify-center items-center w-8 h-8 rounded-full text-cw-900"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-8 w-8"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </div>

                <!-- Badge container -->
                <div
                  :style="{ top: '0.5rem' }"
                  class="w-full h-full absolute left-0 flex items-end justify-center"
                >
                  <img
                    v-if="i === 0"
                    class="h-5"
                    src="/img/cloud_badges/badge_shares_gold.png"
                    alt="CareerWise tenant category leader badge"
                  />
                  <img
                    v-if="i === 1"
                    class="h-5"
                    src="/img/cloud_badges/badge_shares_silver.png"
                    alt="CareerWise tenant category leader badge"
                  />
                  <img
                    v-if="i === 2"
                    class="h-5"
                    src="/img/cloud_badges/badge_shares_bronze.png"
                    alt="CareerWise tenant category leader badge"
                  />
                </div>
              </div>
              <div class="flex flex-1 items-center justify-between space-x-2">
                <div class="">
                  <h6
                    v-if="leader.name"
                    :style="{ maxWidth: '100px' }"
                    class="text-truegray-500"
                  >
                    {{ leader.name }}
                  </h6>
                  <a
                    ref="viewProfile"
                    :href="settings.cloud_domain + 'school/' + leader.id"
                    target="_blank"
                    class="text-xs text-truegray-400 hover:text-cw-alt no-underline italic"
                    ><h6>cloud profile</h6></a
                  >
                </div>
                <h6
                  v-if="leader.total"
                  class="text-xs text-expo_red mb-0 font-bold"
                >
                  {{ leader.total }}
                </h6>
              </div>
            </div>
          </div>
        </div>

        <div class="flex flex-col w-1/3">
          <div class="flex space-x-2 items-center mt-4">
            <img
              class="h-8"
              src="/img/cloud_badges/badge_avg_gold.png"
              alt="CareerWise tenant category leader badge"
            />
            <h3 class="text-lg mb-0">Average Shares</h3>
          </div>
          <div class="w-full flex flex-col justify-center">
            <div
              v-for="(leader, i) in cloudTenantLeaders.share_avg"
              :key="i"
              class="flex items-center my-4"
            >
              <a
                ref="viewProfile"
                :href="settings.cloud_domain + 'school/' + leader.id"
                target="_blank"
                class="hidden"
              ></a>
              <h6 v-if="i === 0" class="text-xs text-truegray-500 mr-2">1st</h6>
              <h6 v-if="i === 1" class="text-xs text-truegray-500 mr-2">2nd</h6>
              <h6 v-if="i === 2" class="text-xs text-truegray-500 mr-2">3rd</h6>
              <div
                class="rounded-full flex items-center justify-center border-2 shrink-0 w-12 h-12 mr-2 relative"
              >
                <div
                  v-if="leader.logo"
                  class="bg-no-repeat bg-cover bg-center w-8 h-8 rounded-full"
                  :style="{ backgroundImage: 'url(' + leader.logo + ')' }"
                ></div>
                <div
                  v-else
                  class="flex justify-center items-center w-8 h-8 rounded-full text-cw-900"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-8 w-8"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </div>

                <!-- Badge container -->
                <div
                  :style="{ top: '0.5rem' }"
                  class="w-full h-full absolute left-0 flex items-end justify-center"
                >
                  <img
                    v-if="i === 0"
                    class="h-5"
                    src="/img/cloud_badges/badge_avg_gold.png"
                    alt="CareerWise tenant category leader badge"
                  />
                  <img
                    v-if="i === 1"
                    class="h-5"
                    src="/img/cloud_badges/badge_avg_silver.png"
                    alt="CareerWise tenant category leader badge"
                  />
                  <img
                    v-if="i === 2"
                    class="h-5"
                    src="/img/cloud_badges/badge_avg_bronze.png"
                    alt="CareerWise tenant category leader badge"
                  />
                </div>
              </div>
              <div class="flex flex-1 items-center justify-between space-x-2">
                <div class="">
                  <h6
                    v-if="leader.name"
                    :style="{ maxWidth: '100px' }"
                    class="text-truegray-500 mb-2"
                  >
                    {{ leader.name }}
                  </h6>
                  <a
                    ref="viewProfile"
                    :href="settings.cloud_domain + 'school/' + leader.id"
                    target="_blank"
                    class="text-xs text-truegray-400 hover:text-cw-alt no-underline italic font-light"
                    ><h6>cloud profile</h6></a
                  >
                </div>
                <h6
                  v-if="leader.total"
                  class="text-xs text-expo_red mb-0 font-bold"
                >
                  {{ leader.total }}
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="!loaded"
        class="w-full flex flex-col space-y-2 items-center justify-center mt-4"
      >
        <div
          class="h-16 w-16 bg-truegray-300 rounded-full flex flex-col justify-center items-center"
        >
          <lottie :options="loadingAnimationOptions" />
        </div>
        <span class="text-center">Loading stats</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as loadingAnimation from '../../../../../shared/components/loading.json'

export default {
  data() {
    return {
      loaded: false,
      loadingAnimationOptions: { animationData: loadingAnimation.default },
      loadingAnimate: false,

      active_range: '90days',

      cloudTenantLeaders: {},
    }
  },

  computed: {
    ...mapGetters({
      settings: 'shared/getSettings',
      storeCloudTenantLeaders: 'careerwise/getCloudTenantLeaders',
    }),
  },

  mounted() {
    this.getStatsLeaders('90days')
  },

  methods: {
    getStatsLeaders(range) {
      this.active_range = range
      this.$set(this, 'loaded', false)
      let submitData = {}

      submitData.range = range
      submitData.postsTenants = this.storeCloudTenantLeaders.posts
      submitData.sharesTenants = this.storeCloudTenantLeaders.shares
      submitData.avgSharesTenants = this.storeCloudTenantLeaders.share_avg

      axios.post('/api/cloud-category-leaders', submitData).then((response) => {
        let result = response.data
        if (result.success) {
          this.$set(this, 'cloudTenantLeaders', result.leaders)
          this.$set(this, 'loaded', true)
        }
      })
    },
  },
}
</script>

<style scoped>
.loading-animation {
  transition: all 1s ease-in-out;
}

.hotshot {
  background: -webkit-linear-gradient(45deg, var(--cw-700), var(--cw-alt));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}
</style>
